import bowser from 'bowser';

/**
 * Converts the SVGs properties in IE so that their size can be dependent on aspect ratio.
 * Using 'width: auto' or 'width: 100%' with IE causes the SVG width to be 300px.
 * This allows the SVG to be sized via height as well as being more flexible in width.
 */
const siteSVGs = function() {
	const
		$html = document.querySelector( 'html' ),
		$svgs = document.querySelectorAll( 'svg' );

	// Update some browser classes.
	if ( ! bowser.msie ) {

		// For non-IE browsers.
		// They behave properly with SVGs, so we won't penalize them.
		$html.classList.add( 'no-ie' );
		return;

	} else {

		// For IE
		$html.classList.add( 'ie' );
	}

	// Loop through all SVGs on the page
	for ( let index = 0; index < $svgs.length; index++ ) {
		const
			$svg         = $svgs[index],
			$container   = $svg.parentNode,
			viewBox      = $svg.getAttribute( 'viewBox' ),
			viewBoxArray = viewBox.split( ' ' ),
			width        = viewBoxArray[2],
			height       = viewBoxArray[3],
			padding      = 100 * height / width,
			styles       = {
				'padding-bottom': `${padding}%`,
				'width': `calc( ${width}/${height} * 1em )`,
				'height': '1px'
			};;

		// Only apply these updates to SVGs that are put in inline.
		if ( ! $container.classList.contains( 'attachment-svg' ) ) {
			continue;
		}

		// Add a class to the container for easier CSS.
		$container.classList.add( 'attachment-svg--ie-pad' );

		// Loop through the styles and apply them to the SVG.
		for ( const key in styles ) {
			if ( styles.hasOwnProperty( key ) ) {
				const value = styles[key];

				$svg.style[key] = value;
			}
		}

		// Finally, update the aspect ratio attribute.
		$svg.setAttribute( 'preserveAspectRatio', 'xMidYMin slice' );
	}
};

export { siteSVGs };
